import React from "react";
import BusDetailsCard from "./BusDetailsCard";

export default function Bus1() {
  return (
    <BusDetailsCard
      busId="bus1"
      title="Bus 1 - Route Details"
      busName="Bus 1"
      vehicleNo="TN74A1234"
      backTo="/?buses=1"
    />
  );
}